<template>
  <div
    class="container"
    :style="{
      backgroundImage: 'url(' + (coverImgUrl ? coverImgUrl : '') + ')',
      backgroundSize: 'contain',
    }"
  >
    <van-nav-bar title="账号登录" class="fixedtop" />
    <div class="log__box">
      <div class="from_card">
        <form action="post">
          <div class="login_email">
            <img src="../../assets//image/jin_03.png" alt />
            <input
              type="text"
              placeholder="请输入账号"
              placeholder-class="add"
              @blur="validEmail"
              v-model="email"
            />
          </div>
          <div class="login_email">
            <img src="../../assets//image/jin_02.png" alt />
            <input
              type="password"
              placeholder="请输入密码"
              maxlength="16"
              minlength="6"
              v-model="password"
              @blur="validPass"
            />
          </div>
          <div class="login_email">
            <img src="../../assets/image/jin_04.png" alt />
            <input class="codeimginput"
              placeholder="请输入验证码"
              v-model="passcode"
            />
            <div class="codeimgdiv">
              <img :src="codeimg" alt="" @click.stop="onclisking" />
            </div>
          </div>
        </form>
        <div class="rember">
          <div class="remember_pass" @click="clickRemember">
            <img src="../../assets//image/jin_06.png" alt v-if="remember" />
            <img src="../../assets//image/jin_05.png" alt v-else />
            <span>记住密码</span>
          </div>
          <div class="forget_pass" @click="toForgetPage">
            <!-- <span>忘记密码?</span> -->
          </div>
        </div>
        <div class="btn_sure" @click="submitLogin">
          <van-button class="van__btu" round size="large">登录</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>
<script>
import axios from 'axios'
import {
  Toast
} from 'vant';
// import * as auth from '@/utils/auth'
import { mapActions } from "vuex"
const Base64 = require('js-base64').Base64
export default {
  name: "login",
  data() {
    return {
      index: 0,
      name: '',

      pass: '',
      secode: '',
      count: '',

      wait: 0,

      email: '',  //lfy6511@163.com
      password: '',      // lfy6511@163.com lfy333666
      counted: '发送验证码',
      coverImgUrl: require('../../assets/image/jin_01.png'),
      remember: false,
      isDisable: false,//防止多次提交

      passcode: '', //验证码
      codeimg: '', //验证码图片
      captcha_id: '', //验证码ID
    };
  },
  created() {
    // 在页面加载时从cookie获取登录信息
    let email = this.getCookie("email")
    let remember = this.getCookie("remember")
    let password = Base64.decode(this.getCookie("password"))
    // 如果存在赋值给表单，并且将记住密码勾选
    if (remember) {
      this.email = email
      this.password = password
      this.remember = remember
    }
    // console.log(email, password,);
    // let routeParams = this.$route.query.wait || ''
    // if (routeParams != '') {
    //   this.wait = routeParams
    // }
    let token = JSON.parse(localStorage.getItem('jin-token'))
    if (token) {
      this.$router.push('/mycollect')
    }
    this.getcodeImg()
  },
  methods: {
    ...mapActions(['userinfo']),
    getAccount() {
      let account = JSON.parse(localStorage.getItem('account'))
      if (account) {
        this.email = account.email
        this.password = account.password
      }
    },
    validEmail() {  // 邮箱验证
      // console.log(this.email);
      let value = this.email
      if (value === '') {
        Toast('请填写账号');
        return
      }
    },
    validPass() {   // 密码验证
      // console.log(this.password);
      let value = this.password
      if (value === '') {
        Toast('请输入密码');
        return
      }
    },
    async getUserInfo() {
      let userInfo = []
      const {
        data: { data }
      } = await this.postRequest("api/user/getUserInfo");
      userInfo = data;
      // console.log(data);
      this.userinfo(userInfo);
    },
    async submitLogin() {   // 登录
      try {
        if (this.email && this.password) {
          const { data } = await this.postRequest('api/lists/password_login', {
            username: this.email,
            password: this.password,
            code: this.passcode,
            code_id: this.captcha_id,
          })
          // console.log(data);
          if (data.code == 1) {
            localStorage.setItem('jin-token', JSON.stringify(data.data.token));
            Toast.success(data.msg)
            this.setUserInfo()
            this.$router.push("/mycollect");

          } else {
            Toast.fail(data.msg)
          }
        } else {
          Toast.fail('邮箱或密码错误')
        }
      } catch (err) {
        // console.log(err);
        // Toast.fail(JSON.stringify(err))
      }

    },
    toForgetPage() {
      // 跳转至忘记密码页面
      // this.$router.push("/forget");
    },
    clickRemember() { // 记住密码
      this.remember = !this.remember
    },
    setUserInfo() {         // 储存表单信息
      if (this.remember) {
        this.setCookie("email", this.email)
        // base64加密密码
        let password = Base64.encode(this.password)
        this.setCookie("remember", this.remember)
        this.setCookie("password", password)
      } else {
        this.setCookie("email", "")
        this.setCookie("password", "")
      }
    },
    getCookie(key) {  // 获取cookie
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + '=')
        if (start !== -1) {
          start = start + key.length + 1
          var end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },
    setCookie(cName, value, expiredays) {      // 保存cookie
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = cName + '=' + decodeURIComponent(value) +
        ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
    },
    goBackFn() {  // 回到上一步
      this.$router.go(-1);
    },
    async getcodeImg() {
      try {
        const { data } = await this.postRequest('api/lists/getCaptcha')
        console.log(axios.defaults.baseURL,111);
        if(data.code == 1){
          this.codeimg = axios.defaults.baseURL + data.data.captcha
          this.captcha_id = data.data.captcha_id
        }else{
          Toast.fail(data.msg)
        }
      } catch (err) {
      }
    },
    onclisking() {
      this.getcodeImg()
    },
    // ----------------------------------------     注册页面     --------------------------------------
    registerPass() {   // 密码验证
      // console.log(this.pass);
      let value = this.pass
      if (value === '') {
        Toast('密码不能为空');
      } else {
        if (value !== '') {
          var pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;//8到16位数字与字母组合
          if (!pwdReg.test(value)) {
            Toast('请输入6-16位的密码，需包含数字、字母');
          }
        }
      }
    },
    registerPass2() {   // 密码验证2
      // console.log(this.password);
      let value = this.password
      if (value === '') {
        Toast('密码不能为空');
      } else {
        if (value !== '') {
          var pwdReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;//8到16位数字与字母组合
          if (!pwdReg.test(value)) {
            Toast('请输入6-16位的密码，需包含数字、字母');
          } else {
            this.validatePassword()
          }
        }
      }
    },
    validatePassword() {
      let pass = this.pass
      let password = this.password
      if (pass == '' || password == '') {
        Toast('密码不能为空')
      } else if (pass == password) {
        Toast('√ 两次输入的密码相同')
        this.registered = true
      } else {
        this.registered = false
        Toast('两次输入的密码不相同')
      }
    },
    checkCode() {  // 发送验证码
      if (this.email != '') {
        if (this.isDisable) {
          return
        } else {
          this.isDisable = true;  //点击后禁用该按钮
          this.getRequest("api/ems/send", {
            email: this.email,
          }).then(res => {
            if (res.code == 0) {
              let msg = res.msg
              Toast(msg)
            } else {
              let msg = res.msg
              Toast(msg)
            }
          })
          const TIME_COUNT = 60;
          this.count = TIME_COUNT;
          this.counted = "已发送" + this.count + '秒'
          if (!this.timer) {
            this.code_show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                this.counted = "已发送" + this.count + '秒';
              } else {
                this.code_show = true;
                clearInterval(this.timer);
                this.counted = '发送验证码'
                this.timer = null;
                this.buttonText = "";
                this.isDisable = false;
              }
            }, 1000);
          }
        }
      } else {
        Toast.fail('未输入邮箱')
      }
    },


  }
};
</script> 

<style scoped lang='less'>
.container {
  width: 100%;
  height: 100%;
  background-color: #064cb2;
  .fixedtop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }
  .vanTab {
    width: 100%;
    padding-top: 80px;
    box-sizing: border-box;
  }
  .left_arrow {
    display: flex;
    align-items: center;
    margin-top: 40px;
    width: 100%;
    height: 44px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .log__box {
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .from_card {
      width: 100%;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 3px 6px 0px #064cb2;
      padding: 24px 16px;
      box-sizing: border-box;

      .login_email {
        width: 100%;
        height: 44px;
        display: flex;
        align-items: center;
        background: #edf4fd;
        border-radius: 22px;
        margin-bottom: 16px;
        padding: 0 16px;
        box-sizing: border-box;
        img {
          width: 24px;
          height: 24px;
        }
        input {
          padding-left: 20px;
          box-sizing: border-box;
          border: 0;
          outline: none;
          background-color: rgba(0, 0, 0, 0);
          flex: 1;
        }
        .codeimginput {
          width: 60%;
        }
        .codeimgdiv {
          width: 40%;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: -16px;
          img {
            width: 100%;
            height: 40px;
            border-radius: 20px;
          }
        }
      }
      .rember {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 6px;
        box-sizing: border-box;
        .remember_pass {
          display: flex;
          align-items: center;

          span {
            color: #5b5e63;
            font-size: 12px;
            margin-left: 5px;
          }
          img {
            width: 16px;
            height: 16px;
          }
        }
        .forget_pass {
          color: #3e8bff;
          font-size: 12px;
        }
      }
      .btn_sure {
        margin-top: 24px;
        width: 100%;
        .van__btu {
          background-color: #3e8bff;
          color: #fff;
          font-size: 16px;
          font-weight: 500;
        }
      }
      .toGister {
        margin-top: 10px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: center;
        p {
          font-size: 12px;
        }
        span {
          color: #416fae;
          font-size: 12px;
        }
      }
    }
    .add {
      color: crimson;
      font-size: 5px;
    }
  }

  .publicStyle {
    padding: 0 41px 41px;
    box-sizing: border-box;

    .divider_ {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 44px;
        height: 44px;
      }
      .dete {
        margin: 50px 0;
        border-color: #707070;
      }
    }
    .member {
      width: 100%;
      .menber_title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 166px;
          height: 25px;
        }
      }
      .content_ {
        display: flex;
        align-items: center;
        height: 60px;

        img {
          width: 18px;
          height: 22px;
        }
        p {
          margin-left: 15px;
          font-size: 12px;
          line-height: 17px;
          color: #666666;
        }
      }
      .end_content {
        width: 100%;
        p {
          text-align: center;
          font-size: 12px;
          color: #ccc;
          span {
            color: #ff0000;
          }
        }
      }
    }
  }
}
</style>